import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { SUPPORT_LANGUAGE } from '../constants';
import { fallbackLocale, locale } from './locale';
import { merge } from 'lodash';
import flat from 'flat';

Vue.use(VueI18n);

const context = require.context('../i18n', true, /[a-z0-9-_]+\.js$/i);
const locales = context.keys().reduce((acc, path) => {
  Object.assign(acc, context(path).default);
  return acc;
}, {});

// Separate each language from locales
const getOwlensLocale = lang => {
  return Object.keys(locales).reduce((messages, key) => {
    messages[key] = locales[key][lang];
    return messages;
  }, {});
};

const i18n = (async () => {
  // 상수로 정의된 "지원되는 언어"를 참조하여 vuetify 언어를 발췌한다.
  const vuetifyLocales = SUPPORT_LANGUAGE.map(locale => import(`vuetify/es5/locale/${locale}.js`));
  const vuetifyLocaleList = await Promise.all(vuetifyLocales);
  const messages = SUPPORT_LANGUAGE.reduce((acc, locale, index) => {
    const owlensLocale = getOwlensLocale(locale); // owlens locale messages
    const vuetifyLocale = flat({ $vuetify: vuetifyLocaleList[index].default }); // vuetify locale messages
    acc[locale] = merge(owlensLocale, vuetifyLocale);
    return acc;
  }, {});

  return new VueI18n({
    locale,
    fallbackLocale,
    messages,
  });
})();

export default i18n;
